export default function Bar_Charts() {
  return <div>Excel_Bar_Charts</div>;
}
